interface LangType {
  [key: string]: {
    ko: string
    en: string
  }
}

interface LangsType {
  [key: string]: {
    title: {
      ko: string
      en: string
    }
    body: {
      title: {
        ko: string
        en: string
      }
      sub: {
        ko: string
        en: string
      }
    }[]
  }[]
}
export const lang: LangType = {
  lang10: {
    ko: `AI For
Connected Car`,
    en: `AI For
Connected Car`,
  },
  lang20: {
    ko: `운전자와 자동차의 상황, 감정 데이터를 활용해 
사용자의 문맥을 이해하는 눈치빠른 AI 서비스를 제공하고 있습니다.`,
    en: ``,
  },
}
export const langs: LangsType = {
  langs10: [
    {
      title: { ko: `차량 상황 인식 AI 모델`, en: `` },
      body: [
        {
          title: { ko: `차량용 센싱값 수집`, en: `` },
          sub: {
            ko: `차량용 데이터 모듈화
차랑위치, 객체인식 카메라 속도
전방출동방지 감지 및 안전벨트 착용 여부
미세먼지, 빗물, 온도 데이터 수집
시간, 날씨, 계절 데이터 수집`,
            en: ``,
          },
        },
        {
          title: { ko: `차량 상황 분류 및 분석 모델`, en: `` },
          sub: {
            ko: `데이터 클러스트링 기법 적용
라이프패턴, 탑승 유형, 운전습관
특수효과 모듈 제작 및 배치 / 작동`,
            en: ``,
          },
        },
      ],
    },
    {
      title: { ko: `SDK 서비스연동 및 LLM, RAG적용`, en: `` },
      body: [
        {
          title: { ko: `차량용 SDK 서비스 연동`, en: `` },
          sub: {
            ko: `이메일 : 수신, 발신, 미확인 정보
캘린더 : 개인/공유 일정, 일시 장소
네비게이션 : 목적지, 교통상황, 시간
데이터 정형화 및 클라우드 저장`,
            en: ``,
          },
        },
        {
          title: { ko: `LLM 모델 및 RAG기법 적용`, en: `` },
          sub: {
            ko: `초거대언어 모델 (LLM, Large Language Model)에 
정형화 된 사용자의 상황 및 감정 정보를 
검색증강생성 기법(RAG, Retrival-Augmented Generation) 
기법으로 학습합니다.`,
            en: ``,
          },
        },
      ],
    },
    {
      title: { ko: `운전자 감정 인식 AI 모델`, en: `` },
      body: [
        {
          title: { ko: `운전자 모니터링 시스템 활용`, en: `` },
          sub: {
            ko: `차량용 데이터 수집 모듈 적용
CAN통신, 클라우드 서버 연동`,
            en: ``,
          },
        },
        {
          title: { ko: `멀티모달 감정 인식 모델`, en: `` },
          sub: {
            ko: `얼굴 감정인식 모델 적용
텍스트 감정인식 모델 적용
음성 감정인식 모델 적용
결정나무 모델 종합 감정 인식`,
            en: ``,
          },
        },
      ],
    },
  ],
  langs20: [
    {
      title: { ko: `대화형 안내 챗봇`, en: `` },
      body: [
        {
          title: { ko: `차량 상황 인식`, en: `` },
          sub: {
            ko: `차량 센서가 동승자 여부와 대화, 취향, TPO 데이터를 수집합니다.`,
            en: ``,
          },
        },
        {
          title: { ko: `운전자 감정 인식`, en: `` },
          sub: {
            ko: `차량의 운전자 감정 인식 시스템은 운전 중 졸림, 분노, 중립, 고민, 당혹감 등 
다양한 감정을 감지합니다.`,
            en: ``,
          },
        },
        {
          title: { ko: `AI 비서 제공 서비스`, en: `` },
          sub: {
            ko: `사용자의 상황에 맞춰 AI 비서가 현재 위치, 교통 상황, 사용자의 선호도 등을 
종합적으로 고려하여 음식 맛집, 사진 명소 등을 추천합니다.`,
            en: ``,
          },
        },
      ],
    },
    {
      title: { ko: '분위기 전환 1', en: `` },
      body: [
        {
          title: { ko: `차량 상황 인식`, en: `` },
          sub: {
            ko: `차량 시스템은 운전자의 일상 패턴을 학습해, 예를들어
퇴근 시간에 맞춰 네비게이션을 분석합니다.`,
            en: ``,
          },
        },
        {
          title: { ko: `운전자 감정 인식`, en: `` },
          sub: {
            ko: `운전 중 교통 정체나 우회경로에 화나거나 짜증날 때, 
차량의 감정 인식 시스템이 이를 감지합니다.`,
            en: ``,
          },
        },
        {
          title: { ko: `AI 비서 제공 서비스`, en: `` },
          sub: {
            ko: `운전 중 기분에 맞는 음악 추천과 교통 정체 시 우회 경로 안내로 
운전 경험을 개인화하고 쾌적하게 만듭니다.`,
            en: ``,
          },
        },
      ],
    },
    {
      title: { ko: '분위기 전환 2', en: `` },
      body: [
        {
          title: { ko: `차량 상황 인식`, en: `` },
          sub: {
            ko: `여행 중 차량 시스템은 네비게이션으로 경로를 분석하고, 특수 도로 상황을 파악합니다. 
또한, 미세먼지와 온도 데이터를 수집합니다.`,
            en: ``,
          },
        },
        {
          title: { ko: `운전자 감정 인식`, en: `` },
          sub: {
            ko: `고속도로 운전 중 졸음을 느낄 때, 차량의 감정 인식 시스템이
졸림을 감지합니다.`,
            en: ``,
          },
        },
        {
          title: { ko: `AI 비서 제공 서비스`, en: `` },
          sub: {
            ko: `졸림 감지 시, AI 비서는 경고를 보내고 졸음 방지 음악을 재생하며, 
필요하면 속도 조절과 안전한 주차를 추천해 운전자가 휴식을 취하도록 돕습니다.`,
            en: ``,
          },
        },
      ],
    },
    {
      title: { ko: '업무 보조', en: `` },
      body: [
        {
          title: { ko: `차량 상황 인식`, en: `` },
          sub: {
            ko: `차량 시스템은 출근과 출장 패턴을 알고, 캘린더와 이메일로 일정과 미팅 정보를 
확인하며, 검색엔진으로 미팅 기업과 참석자를 파악합니다.`,
            en: ``,
          },
        },
        {
          title: { ko: `운전자 감정 인식`, en: `` },
          sub: {
            ko: `출근이나 시내 출장 시, 운전자의 긴장, 중립, 고민 등의 감정을 감지합니다.`,
            en: ``,
          },
        },
        {
          title: { ko: `AI 비서 제공 서비스`, en: `` },
          sub: {
            ko: `미팅 일정을 리마인드하고, 관련 정보를 전달 및 요약해 줍니다.
또한, 미팅 전략까지 제안하여 준비와 진행을 원활하게 돕습니다.`,
            en: ``,
          },
        },
      ],
    },
  ],
}
